<div class="snackbar-content" [ngClass]="data.action">
    <ng-container *ngIf="data.action === 'success' || data.action === ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" class="bell-icon">
            <path fill="#0caa4e"
                d="M12 4.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5v1.53c-2.25.25-4 2.15-4 4.47v5.91L5.41 18h12.18L16 16.41V10.5c0-2.32-1.75-4.22-4-4.47zM11.5 3A1.5 1.5 0 0 1 13 4.5v.71c2.31.65 4 2.79 4 5.29V16l3 3H3l3-3v-5.5C6 8 7.69 5.86 10 5.21V4.5A1.5 1.5 0 0 1 11.5 3m0 19a2.5 2.5 0 0 1-2.45-2h1.04a1.495 1.495 0 0 0 2.82 0h1.04a2.5 2.5 0 0 1-2.45 2"
                stroke-width="0.1" stroke="rgba(40, 217, 114, 0.443)" />
        </svg>
    </ng-container>

    <ng-container *ngIf="data.action === 'error'">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" class="bell-icon">
            <path fill="#e83e24"
                d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m0 26a12 12 0 1 1 12-12a12 12 0 0 1-12 12" />
            <path fill="#e83e24" d="M15 8h2v11h-2zm1 14a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22" />
        </svg>
    </ng-container>

    <span class="message">{{ data.message }}</span>

    <span class="close-icon" (click)="snackbarRef.dismiss()" role="button" tabindex="0" aria-label="Close notification">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 21">
            <path fill="none" stroke="#a8aeaa" stroke-linecap="round" stroke-linejoin="round"
                d="m15.5 15.5l-10-10zm0-10l-10 10" stroke-width="1.6" />
        </svg>
    </span>
</div>